<markant-platform-modal-bridge>
  <markant-dialog
    *ngIf="removeEmployeeDialogOpen"
    class="remove-member-dialog"
    [headTitle]="'organization.users.remove.header' | transloco"
    [open]="true"
    (close)="removeEmployeeDialogOpen = false; closeChanged.emit()"
  >
    <div>{{ 'organization.users.remove.security-question' | transloco }}</div>
    <div class="flex-row-end remove-dialog-buttons">
      <markant-button
        colorScheme="primary"
        variant="clear"
        (click)="removeEmployeeDialogOpen = false; closeChanged.emit()"
      >
        {{ 'common.cancel' | transloco }}
      </markant-button>
      <markant-button
        colorScheme="primary"
        [loading]="isLoading"
        (click)="removeEmployeeDialogOpen = false; removeUsers()"
      >
        {{ 'organization.users.remove.submit' | transloco }}
      </markant-button>
    </div>
  </markant-dialog>

  <markant-dialog
    *ngIf="noOtherOrgaAdminDialogOpen"
    class="dialog"
    [headTitle]="
      'organization.users.remove.alternativeOwner.availableAdmins.noAdminAvailable.header'
        | transloco
    "
    [open]="true"
    (close)="closeDialog()"
  >
    <div class="info">
      {{
        'organization.users.remove.alternativeOwner.availableAdmins.noAdminAvailable.deleteInfo'
          | transloco
      }}
    </div>
    <div class="button" slot="footer">
      <markant-button
        colorScheme="primary"
        variant="clear"
        (click)="closeDialog()"
      >
        {{ 'common.cancel' | transloco }}
      </markant-button>
    </div>
  </markant-dialog>

  <markant-platform-info-dialog
    *ngIf="isWarningUserDialogOpen"
    [headline]="'organization.users.warningTitle' | transloco"
    [text]="'organization.users.warningLabel' | transloco"
    [buttonText]="'general.close' | transloco"
    (openChange)="closeWarningUserDialog()"
    (submitChange)="closeWarningUserDialog()"
  >
  </markant-platform-info-dialog>

  <markant-platform-service-responsibility-assign-new-admin
    *ngIf="isAssignAdminForServiceBookingResponsibilityOpen"
    [mode]="'delete'"
    [owners]="owners"
    [alternativeOwners]="alternativeOwners"
    (assignNewOwnersToCartridges)="removeMembersAndAssignNewOwners($event)"
    (closed)="closeDialog()"
  >
  </markant-platform-service-responsibility-assign-new-admin>
</markant-platform-modal-bridge>
